import React, { useState } from "react";
import questionAnswers from "./questionSet";
import styles from "./styles";
import withStyles from "@material-ui/core/styles/withStyles";
import QuestionScreen from "../../components/QuestionScreen";
import ThirdScreen from "../../components/ThirdScreen";
import EvaluatorModal from "../../components/DescriptionModal";

const QuizScreen = (props) => {
  const {
    classes,
    setCurrentScreen,
    setAnswers,
    answers,
    totalBalance,
    setTotalBalance,
    ...others
  } = props;

  const [questionIndex, setQuestionIndex] = useState(0);
  const [open, setOpen] = useState(true);
  const [answeredCorrectly, setAnsweredCorrectly] = useState(null);
  const [previousBalance, setPreviousBalance] = useState(0);
  const [showThirdScreen, setShowThirdScreen] = useState(false);

  const modalOpen = () => setOpen(true);

  const nextQuestion = () => {
    // setOpen(false);
    setShowThirdScreen(false)
    console.log("questionAnswers.length", questionAnswers.length)
    setAnswers((prevAnswers) => [...prevAnswers, answeredCorrectly])
    if(questionAnswers.length - 1 > questionIndex){
      setQuestionIndex(questionIndex+1)
    }else{
      setCurrentScreen("Result")
      // setQuestionIndex(0) //reseting when reach at end
    }
  };

  const hideModal = () => {
    setOpen(false);
  }

  const addToTotalBalance = (selected) => {
    setPreviousBalance(totalBalance);
    setTotalBalance(
      questionAnswers[questionIndex].prices[selected] + totalBalance
    );
  };

  console.log("questionIndex: ", questionIndex);
  console.log("totalBalance: ", totalBalance);

  return (
    <div className={classes.quizScreenContainer}>
      {open ? (
        <QuestionScreen
          {...others}
          questionAnswer={questionAnswers[questionIndex]}
          modalOpen={modalOpen}
          nextQuestion={nextQuestion}
          key={questionIndex}
          questionIndex={questionIndex}
          setAnsweredCorrectly={setAnsweredCorrectly}
          answeredCorrectly={answeredCorrectly}
          addToTotalBalance={addToTotalBalance}
          totalBalance={totalBalance}
          previousBalance={previousBalance}
          open={true}
        />
      ) : showThirdScreen ?
          <ThirdScreen
          nextQuestion={nextQuestion}
          questionAnswer={questionAnswers[questionIndex]}
          />
          :
          <QuestionScreen
            {...others}
            questionAnswer={questionAnswers[questionIndex]}
            modalOpen={modalOpen}
            open={open}
            nextQuestion={nextQuestion}
            key={questionIndex}
            questionIndex={questionIndex}
            setAnsweredCorrectly={setAnsweredCorrectly}
            answeredCorrectly={answeredCorrectly}
            addToTotalBalance={addToTotalBalance}
            totalBalance={totalBalance}
            previousBalance={previousBalance}
            setShowThirdScreen={setShowThirdScreen}
          />
        }

      <EvaluatorModal
        open={open}
        answeredCorrectly={answeredCorrectly}
        hideModal={hideModal}
        question={questionAnswers[questionIndex]}
      />
    </div>
  );
};

export default withStyles(styles)(QuizScreen);
